import { get } from 'lodash';

/**
 * The ValidatorMixin provides common data, methods and props used in both the
 * InputValidator and the TextareaValidator components. It mixes in a common
 * interface so both components behave consistently for clients.
 */
export default {
  inject: ['$validator'],

  props: {
    config: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },

  data() {
    return {
      OptionalValidationModel: get(this.$props, 'config.value', null),
    };
  },

  watch: {
    config: function config(newValue, oldValue) {
      if (newValue.value === oldValue.value) return;

      this.OptionalValidationModel = newValue.value;
    },
  },

  mounted() {
    const validatorItem = this.$validator.fields.items
      .find(item => item.name === this.config.name);

    if (validatorItem) {
      validatorItem.events = ['InputValidatorModel', 'blur'];
    }
  },

  methods: {
    getInputChild() {
      return this.$children[0];
    },

    handleBlur(change, ...args) {
      this.$emit('InputValidatorBlur', change, this.config.attribute, this.config.name, args);
    },

    handleChange(change, ...args) {
      this.$emit('InputValidatorChange', change, this.config.attribute, this.config.name, args);
    },

    handleEnter(change, ...args) {
      this.$emit('InputValidatorEnter', change, this.config.attribute, this.config.name, args);
    },

    handleFocus(change, ...args) {
      this.$emit('InputValidatorFocus', change, this.config.attribute, this.config.name, args);
    },

    handleInput(change, ...args) {
      this.$emit('InputValidatorModel', change, this.config.attribute, this.config.name, args);
    },
  },
};
